<main class="main-home-secton">
  <div class="event-main">
    <div class="container">
      <div class="event-details-div">
        <div class="row">
          <div class="col-lg-4 col-md-4 col-sm-12 col-12">
            <div class="event-titles-details">
              <h1>{{ eventView.eventName }}</h1>
            </div>
            <div class="" style="word-wrap: break-word">
              <ion-icon name="location-outline"></ion-icon>
              {{ eventView.eventLocation }}
            </div>
            <hr />
            <div class="incubator-detail-div">
              <div class="d-flex">
                <div>
                  <img
                    [src]="eventView.incubatorLogo"
                    class="img-fluid img-logo"
                    alt=""
                  />
                </div>
                <div class="ml-3">
                  <h5>{{ eventView.incubatorName }}</h5>
                </div>
              </div>
            </div>
            <hr />
            <div class="event-date mt-4">
              <div class="row mb-3">
                <div class="col-6 date-div">
                  <ion-icon name="calendar-clear-outline"></ion-icon> Start Date
                  <h5 class="date-h5">
                    {{ eventView.eventFromDate }}
                  </h5>
                </div>
                <div class="col-6 date-div" *ngIf="eventView.eventToDate">
                  <ion-icon name="calendar-clear-outline"></ion-icon> End Date
                  <h5 class="date-h5">
                    {{ eventView.eventToDate }}
                  </h5>
                </div>
              </div>
              <hr />
              <div class="row">
                <div class="col-6 date-div">
                  <ion-icon name="time-outline"></ion-icon> Start Time
                  <h5 class="date-h5">
                    {{ eventView.eventFromTime }}
                  </h5>
                </div>
                <div class="col-6 date-div" *ngIf="eventView.eventToTime">
                  <ion-icon name="time-outline"></ion-icon> End Time
                  <h5 class="date-h5">
                    {{ eventView.eventToTime }}
                  </h5>
                </div>
              </div>
              <hr />
            </div>
            <div class="event-reg">
              <h5>Registration Details</h5>
              <div class="row">
                <div class="col-6" *ngIf="eventView.eventRegQRFileName">
                  <h6>QR Code</h6>
                  <div>
                    <img
                      [src]="eventView.eventRegQRFileName"
                      class="img-fluid"
                      alt=""
                    />
                  </div>
                </div>
                <div class="col-6">
                  <div *ngIf="eventView.eventFromDate">
                    <ion-icon name="calendar-clear-outline"></ion-icon> Last
                    Date
                    <h5 class="date-h5">
                      {{ eventView.eventFromDate }}
                    </h5>
                  </div>
                  <div *ngIf="eventView.eventRegLink" class="pt-3">
                    <a [href]="eventView.eventRegLink" target="_blank"
                      >Registration Link</a
                    >
                  </div>
                  <div *ngIf="eventView.eventWebsiteLink" class="pt-3">
                    <a [href]="eventView.eventWebsiteLink" target="_blank"
                      >Website Link</a
                    >
                  </div>
                </div>
              </div>
            </div>
          </div>
          <div class="col-lg-8 col-md-8 col-sm-12 col-12">
            <div class="event-form-div">
              <img
                [src]="eventView.eventImageName"
                class="img-fluid event-img"
                alt=""
              />
            </div>
            <div class="event-descrption" *ngIf="eventView.eventDescription">
              <h5>Description</h5>
              <div [innerHtml]="eventView.eventDescription | safeHtml"></div>
            </div>
          </div>
          <div class="col-12 text-center">
            <button
              mat-raised-button
              color="warn"
              (click)="backBtn()"
              [ngClass]="{ 'd-none': roleValue == 'Incubator' }"
            >
              <ion-icon name="arrow-back-outline"></ion-icon> Back
            </button>
            <button
              mat-raised-button
              color="warn"
              *ngIf="roleValue == 'Incubator'"
              (click)="backBtn2()"
            >
              <ion-icon name="arrow-back-outline"></ion-icon> Back
            </button>
          </div>
        </div>
      </div>
    </div>
  </div>
</main>
<app-footer></app-footer>
